import { useSelector } from 'react-redux';

import { scale } from '@components/frame';

import { isPhone, isWeb } from '@helpers';

import { getBoxShadowStyle } from '@styles/shadow';

import { selectSelectedItem } from '@reducers/machines';
import { selectClampingTools, selectClampingToolsLoaded } from '@reducers/clampingTools';

import {
  SCREEN_BORDER_RADIUS,
  SCREEN_MARGIN_BOTTOM_PHONE,
  SCREEN_MARGIN_BOTTOM_WEB,
  SCREEN_PADDING_VERTICAL_FOR_ITEM,
  NOT_PANEL_VIEW_MODE_WIDTH,
} from '../../../../../../common/constants/base.constants';
import { usePanelViewMode } from '@v2/pages/machines/hooks/usePanelViewMode';
import { WithColor } from '@styles/colors';

interface UseManageToolsGeneralContentParams extends WithColor {
  maxDetailsWidth?: number;
  bg?: string;
}

export const useManageToolsGeneralContent = ({
  maxDetailsWidth = NOT_PANEL_VIEW_MODE_WIDTH,
  bg = 'Background/Light/Field',
  C,
}: UseManageToolsGeneralContentParams) => {
  const selectedItem = useSelector(selectSelectedItem);
  const clampingTools = useSelector(selectClampingTools);
  const loaded = useSelector(selectClampingToolsLoaded);

  const { panelViewMode } = usePanelViewMode();

  const ncFileName = selectedItem?.machineStatus?.ncFile;
  const ncFileId = selectedItem?.machineStatus?.ncFileId;
  const isNCFile = !!ncFileName;

  const borderRadiusConfig = {
    borderRadius: scale(SCREEN_BORDER_RADIUS),
  };

  const shouldDisplayBackgroundAndShadow = isNCFile && !!clampingTools.length && loaded;

  const containerStyle = {
    flex: 1,
    width: '100%' as const,
    alignItems: 'center' as const,
    paddingTop: scale(SCREEN_PADDING_VERTICAL_FOR_ITEM),
    marginBottom: scale(isPhone ? SCREEN_MARGIN_BOTTOM_PHONE : SCREEN_MARGIN_BOTTOM_WEB),
  };

  const contentStyle = [
    { height: '100%' as const, flex: 1 },
    shouldDisplayBackgroundAndShadow && {
      backgroundColor: C(bg),
      ...getBoxShadowStyle({ type: 'Field', C }),
    },
    !isWeb && {
      overflow: 'hidden' as const,
    },
    borderRadiusConfig,
  ];

  return {
    selectedItem,
    panelViewMode,
    ncFileName,
    ncFileId,
    maxDetailsWidth,
    containerStyle,
    contentStyle,
  };
};
